<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link :to="booksPath">小説管理</router-link></li>
                <li class="breadcrumb-item"><router-link :to="`/mypage/book/${$route.params.book_id}/sections`">本文一覧</router-link></li>
                <li class="breadcrumb-item">あらすじ</li>
            </ol>
        </nav>
        <legend class="text-center my-4">
            <h3 v-if="book.id" class="mincho" v-html="$filters.ruby(book.title + ' のあらすじ')"></h3>
            <h4 class="subtitle mincho" v-if="book.subtitle">{{book.subtitle}}</h4>
        </legend>
        <div class="d-flex justify-content-center" v-if="outlines.length">
            <div class="slider">
                <div class="slider-item" v-for="o in outlines" :key="o.id">
                    <img :src="o.picture.thumb_url + '?hash=' + o.picture.hash" class="episode-bg" v-if="o.picture">
                    <div class="d-flex justify-content-between">
                        <button class="btn btn-link text-primary btn-sm" @click="edit(o.section_id)">
                            編集
                        </button>
                        <button class="btn btn-link text-danger btn-sm" @click="remove(o)">
                            削除
                        </button>
                    </div>
                    <div class="episode-number">
                        エピソード{{o.section.episode_number}}
                    </div>
                    <div class="episode-title mincho">
                        {{o.section.section_name}}
                    </div>
                    <div class="synopsis mincho" v-html="synopsis(o)"></div>
                    <div class="episode-chars">
                        {{ $filters.numberFormat(o.section.characters) }} 文字
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="d-flex justify-content-center">
            <div class="instruction">
                <p>
                    ３話までのエピソードへ１４０文字以内のあらすじを記載できます。
                </p>
                <p>
                    冒頭のあらすじを記載することで、初見の読者に向けて物語を手に取るきっかけを作ります。
                    単純な流れを短くまとめるだけで構いません。
                </p>
                <p>
                    あらすじはポータルの小説カード、目次ページに表示されます。
                </p>
            </div>
        </div>
        <div class="container contents">
            <div class="d-flex justify-content-start section" v-for="s in book.sections" :key="s.id">
                <button class="btn btn-outline-primary mr-3" @click="edit(s.id)"
                    :disabled="!canSelect(s)"
                    v-if="!s.is_chapter">
                    <i class="fas fa-pen"></i>
                </button>
                <div class="section-name">
                    {{s.section_name}}
                </div>
            </div>
        </div>
        <outline-editor
            :section_id="section_id"
            @saved="load()"></outline-editor>
    </div>
</template>

<style scoped lang="scss">
.slider {
    display: flex;
    overflow: scroll;
    margin: 0 15px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    margin: 2rem 0;
    justify-content: center;
    flex-wrap: wrap;
    &::-webkit-scrollbar {
        display:none;
    }
    .slider-item {
        width: 210px;
        padding: 10px 15px 35px;
        border-radius: .5rem;
        background-color: #aaaaaa30;
        margin: 1rem;
        position: relative;
        overflow: hidden;
        .episode-bg {
            pointer-events: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 210px;
            height: 333px;
            opacity: 0.15;
            object-fit: cover;
        }
        .episode-number {
            font-size: 0.7rem;
            opacity: 0.8;
        }
        .episode-title {
            font-size: 1rem;
            margin: .5rem 0;
        }
        .synopsis {
            letter-spacing: 0.05rem;
            font-size: 0.7rem;
            opacity: 0.8;
        }
        .episode-chars {
            font-size: 0.7rem;
            text-align: right;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            padding: 0 1rem 0.5rem;
            opacity: 0.8;
        }
    }
}
.instruction {
    max-width: 640px;
    margin: 3rem auto;
    padding: 1rem;
    background-color: #83804c;
    border-radius: .5rem;
    color: snow;
    text-align: left;
    position: relative;
    &:before {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -15px;
        border: 15px solid transparent;
        border-top: 15px solid #83804c;
    }
}
.contents {
    width: 640px;
    .section-name {
        padding: .25rem;
        font-size: 1.35rem;
    }
    .section {
        padding: .5rem;
        margin-bottom: 1rem;
        background-color: #aaa3;
        border-radius: .5rem;
    }
}
</style>

<script>
import outlineEditor from "./outlineEditor";
export default {
    components: {
        outlineEditor
    },
    data() {
        return {
            book: {},
            outlines: [],
            section_id: null,
        }
    },
    methods: {
        load() {
            axios.get("/mypage/outlines/get", {params: {
                id: this.$route.params.book_id
            }}).then(res => {
                this.outlines = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        loadBook() {
            axios.get("/mypage/outlines/book", {params: {
                id: this.$route.params.book_id
            }}).then(res => {
                this.book = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        edit(id) {
            this.section_id = id;
            setTimeout(() => {
                $("#outline-editor").modal();
            });
        },
        canSelect(s) {
            if (_.find(this.outlines, {section_id: s.id})) {
                return false;
            }
            if (this.outlines.length >= 3) {
                return false;
            }
            return true;
        },
        remove(o) {
            let msg = "";
            if (o.picture) {
                msg = "画像も併せて削除されます。";
            }
            Swal.fire({
                title: "あらすじ削除",
                text: `指定のあらすじを削除します。${msg}\nよろしいですか？`,
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/books/outline/remove", {id: o.id}).then(res => {
                        this.load();
                    }).catch(err => { alert.err(err.response) });
                }
            });
        },
        synopsis(o) {
            return this.$filters.ruby(this.$filters.truncate(o.synopsis || o.section.body.replace(/<i\d+\|\d+>/ug, '').trim(), 140));
        }
    },
    computed: {
        booksPath() {
            if (this.book?.is_hidden === 3) {
                return "/mypage/books/pending";
            } else if (this.book?.property?.is_finished) {
                return "/mypage/books/finished";
            }
            return "/mypage/books/writing";
        },
    },
    mounted() {
        this.load();
        this.loadBook();
    }
}
</script>